import { useDispatch } from "react-redux";
import {
  emptyNodeDataObject,
  updateModalsCloseDrawerModal,
  updateNodeSelectionNodeData,
  updateNodeSelectionState,
} from "@src/reducers/your-reducer";
import dashboardSetupIcon from "@src/assets/svg/dashboard-setup-blue-icon.svg";

export const useControlBarDashboardSetupButtonHook = () => {
  const dispatch = useDispatch();

  const openDashboardSetupDrawer = () => {
    dispatch(
      updateModalsCloseDrawerModal({ showModal: true, id: "tileDrawerModal" }),
    );
    dispatch(updateNodeSelectionState("none"));
    dispatch(updateNodeSelectionNodeData(emptyNodeDataObject));
  };

  const icon = dashboardSetupIcon;
  const disabled = false;

  return {
    icon,
    disabled,
    openDashboardSetupDrawer,
  };
};
